$(() => {
	$("body").removeClass("preload");
});